import { t } from 'i18next'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { API_OBSERVATION_FILE } from '../../../constants'
import { RequestMethod } from '../../../model/enums/enums'
import { Observation, ObservationFile } from '../../../model/observation'
import { useAppDispatch } from '../../../redux/hooks'
import { observationUpdated } from '../../../redux/official-document/education-report/observation/observationReducer'
import { handleRequest } from '../../../services/api/base/handleRequest'
import { actionBodyDelete } from '../../util/data-table/cell-body/ActionBody'
import { FileTypeIcon } from '../../util/icon/FileTypeIcon'

export const ObservationFileList = (props: {
  observation: Observation | undefined;
}): JSX.Element => {
  const { getValues, setValue } = useFormContext()

  const typeBody = (rowData: ObservationFile): JSX.Element => {
    if (!rowData) {
      return <></>
    }
    const fileExt = rowData.file_name?.split('.').pop()?.toLowerCase()
    if (!fileExt) {
      return <></>
    }
    const typeIcon = FileTypeIcon(fileExt)

    if (!typeIcon) {
      return <></>
    }
    return typeIcon
  }
  const dispatcher = useAppDispatch()

  const deleteEntry = async (rowData: ObservationFile) => {
    if (!props.observation) {
      return
    }
    const result = await handleRequest(
      API_OBSERVATION_FILE(rowData.observation_file_id),
      RequestMethod.DELETE
    )
    if (result.error === undefined) {
      console.log(
        `[Observation File] Successfully deleted the file with id ${rowData.observation_file_id}.`
      )
      
      const observation = {...props.observation}
      observation.observation_file = props.observation.observation_file?.filter(
        (file: ObservationFile) =>
          file.observation_file_id !== rowData.observation_file_id
      )
      dispatcher(observationUpdated(observation))
      setValue('observation_file', observation.observation_file, {
        shouldDirty: true,
      })
    }
  }

  if (getValues('observation_file')?.length > 0) {
    return (
      <DataTable className={'mb-3'} value={getValues('observation_file')}>
        <Column
          header={t<string>('core.attachment')}
          body={typeBody}
          style={{ width: '3em' }}
        />
        <Column field={'file_name'} />
        <Column
          body={actionBodyDelete(deleteEntry)}
          headerStyle={{ width: '60px' }}
          bodyStyle={{ width: '60px' }}
        />
      </DataTable>
    )
  }
  return <Fragment />
}